<template>
  <div class>
    <Toast />

    <div class="content-card">
      <h5>
        <b>Buat Transfer</b>
      </h5>
      <div class="p-grid p-fluid p-mb-3">
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="">Gudang</label>
          <div>
            <AutoComplete
              placeholder="Warehouse"
              :dropdown="true"
              :multiple="false"
              v-model="selectedWarehouse"
              :suggestions="warehouse_filtered"
              @complete="searchWarehouse($event)"
              field="name"
              @input="isError.warehouse_id = false"
            >
              <template #item="slotProps">
                <div>{{ slotProps.item.name }}</div>
                <div style="font-style: italic; font-size: 12px">
                  {{ slotProps.item.code }}
                </div>
              </template>
            </AutoComplete>
          </div>
          <small class="p-error" v-if="isError.warehouse_id">{{
            error_msg.warehouse_id
          }}</small>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="">Nomor Bon</label>
          <div>
            <InputText
              v-model="bon"
              :readonly="true"
              :disabled="true"
              placeholder="Doc Number"
            />
          </div>
        </div>
        <div class="p-col-12 p-md-6 p-lg-4">
          <label for="">Tanggal Bon</label>
          <div>
            <InputText
              type="date"
              :readonly="true"
              :disabled="true"
              v-model="today"
            />
          </div>
        </div>
      </div>

      <div class="p-grid p-fluid">
        <div class="p-col-12">
          <table class="table table-responsive">
            <thead class="thead-light">
              <tr>
                <th>Kode</th>
                <th>Nama</th>
                <th>Stok</th>
                <th>Harga (Rp)</th>
                <th>Jumlah</th>
                <th>Total Harga (Rp)</th>
                <th>Hapus</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  <AutoComplete
                    placeholder="Code"
                    :dropdown="true"
                    :multiple="false"
                    v-model="an_item.selected_item"
                    :suggestions="autoFiltered"
                    @complete="getItems"
                    @input="chooseDropdownChanges(k)"
                    field="code"
                  >
                    <template #item="slotProps">
                      <div>{{ slotProps.item.name }}</div>
                      <div style="font-style: italic; font-size: 12px">
                        {{ slotProps.item.code }}
                      </div>
                    </template>
                  </AutoComplete>
                  <small class="p-error" v-if="isError.items[k].id">{{
                    error_msg.items[k].id
                  }}</small>
                </td>
                <td>
                  <InputText
                    :disabled="true"
                    v-model="an_item.name"
                    placeholder="Name"
                  />
                </td>
                <td>
                  <InputNumber
                    :disabled="true"
                    v-model="an_item.stock"
                    placeholder="0"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputText
                    type="number"
                    v-model="an_item.qty"
                    placeholder="0"
                    @keyup.prevent="qtyChanges(k)"
                    @change="qtyChanges(k)"
                  />
                  <small class="p-error" v-if="isError.items[k].qty">{{
                    error_msg.items[k].qty
                  }}</small>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="an_item.total"
                    :disabled="true"
                  />
                </td>
                <td class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td class="p-text-right">
                  <label for="">Total</label>
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_qty"
                    :disabled="true"
                  />
                </td>
                <td>
                  <InputNumber
                    mode="decimal"
                    locale="de-DE"
                    v-model="total_price"
                    :disabled="true"
                  />
                </td>
                <td>
                  <Button
                    icon="pi pi-plus"
                    label="Tambah"
                    class="p-mr-2"
                    @click="addNewRow()"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="p-grid p-justify-center">
        <div class="p-col-12 p-md-6 p-lg-3">
          <button
            type="button"
            class="btn btn-primary"
            style="width: 100%"
            @click="saveChanges"
            :disabled="loading.createButton"
          >
            Buat
            <span v-if="loading.createButton">
              <i class="pi pi-spin pi-spinner" style="font-size: 12px"></i>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data() {
    return {
      today: new Date().toISOString().split('T')[0],
      bon: null,
      autoFiltered: [],
      warehouse_filtered: [],
      selectedWarehouse: null,
      selectedWarehouses: null,
      items_checked: false,
      isError: {
        warehouse_id: false,
        doc_number: false,
        doc_date: false,
        items: [{ id: false, qty: false }]
      },
      error_msg: {
        warehouse_id: '',
        doc_number: '',
        doc_date: '',
        items: [{ id: '', qty: '' }]
      },
      items: [],
      total_price: 0,
      total_qty: 0,
      items_temp: [
        {
          selected_item: '',
          name: '',
          stock: 0,
          qty: null,
          price: 0,
          total: 0,
          description: ''
        }
      ],
      inputData: {
        warehouse_id_destination: 0,
        doc_number: '',
        doc_date: '',
        items: [
          {
            id: 0,
            qty: 0,
            description: ''
          }
        ]
        // type: 'RETURN'
      },
      loading: {
        createButton: false
      }
    }
  },
  computed: mapState(['user', 'isAuthenticated']),
  mounted() {
    this.getListWarehouse()
    this.getItems()
  },
  methods: {
    async getListWarehouse() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouses`
        )
        if (response.status === 200) {
          this.selectedWarehouses = response.data.data.warehouses.filter(
            warehouse => warehouse.id !== this.user.warehouse_id
          )
        }
      } catch (error) {
        console.error('Error fetching warehouses:', error)
      }
    },

    searchWarehouse(event) {
      this.warehouse_filtered = this.selectedWarehouses.filter(item => {
        return (
          item.name.toLowerCase().startsWith(event.query.toLowerCase()) ||
          item.code.toLowerCase().startsWith(event.query.toLowerCase())
        )
      })
    },

    getItems(event) {
      // let code = event?.query ?? '' -> not support new babel version, so use this below
      let code
      if (event != null && event.query != null) {
        code = event.query
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&limit=5`
        )
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.data.items
            this.bon = response.data.data.doc_number
            this.autoFiltered = this.filterItems(event)
          }
        })
    },

    filterItems(event) {
      let query
      if (event != null && event.query != null) {
        query = event.query
      }
      const lowerCaseQuery = query.toLowerCase()
      return this.items.filter(item => {
        return (
          item.name.toLowerCase().indexOf(lowerCaseQuery) === 0 ||
          item.code.toLowerCase().indexOf(lowerCaseQuery) === 0
        )
      })
    },

    chooseDropdownChanges(index) {
      for (const item of this.inputData.items) {
        // check if item is searchItems
        if (item.id === this.items_temp[index].selected_item.id) {
          this.showToast('error', 'Error Message', 'Barang sudah dipilih')
          // clear selected item
          this.items_temp[index].selected_item = ''
          this.items_temp[index].name = ''
          this.items_temp[index].stock = 0
          this.items_temp[index].price = 0
          this.inputData.items[index].id = 0
          this.inputData.items[index].qty = 0
          this.items_temp[index].qty = null
          return
        }
      }
      if (this.items_temp[index].selected_item instanceof Object) {
        this.isError.items[index].id = false

        this.inputData.items[index].id = this.items_temp[index].selected_item.id
        this.items_temp[index].price = parseFloat(
          this.items_temp[index].selected_item.cap_price
        )
        this.items_temp[index].name = this.items_temp[index].selected_item.name
        this.items_temp[index].stock =
          this.items_temp[index].selected_item.stock

        this.calculateLineTotal(index)
      }
    },

    qtyChanges(index) {
      this.isError.items[index].qty = false
      this.inputData.items[index].qty = parseInt(this.items_temp[index].qty)
      this.calculateLineTotal(index)
    },

    calculateLineTotal(index) {
      let qty = parseInt(this.items_temp[index].qty) || 0

      this.items_temp[index].total = qty * this.items_temp[index].price
      this.calculateTotal()
    },

    calculateTotal() {
      this.total_price = this.items_temp.reduce(function (sum, item) {
        return sum + item.total
      }, 0)

      this.total_qty = this.items_temp.reduce(function (sum, item) {
        const qty = parseInt(item.qty) || 0 // Mengubah qty menjadi integer atau berikan nilai default 0 jika tidak valid
        return (sum += qty)
      }, 0)
    },

    saveChanges() {
      if (this.selectedWarehouse instanceof Object) {
        this.inputData.warehouse_id_destination = this.selectedWarehouse.id
      } else {
        this.isError.warehouse_id = true
        this.error_msg.warehouse_id = 'choose this input first'
      }

      this.inputData.doc_date = this.today
      this.inputData.doc_number = this.bon
      this.inputData.type = 'TRANSFER'

      for (let i = 0; i < this.inputData.items.length; i++) {
        if (
          !this.inputData.items[i].id <= 0 ||
          !this.inputData.items[i].id === '0'
        ) {
          this.items_checked = true
        } else {
          this.isError.items[i].id = true
          this.error_msg.items[i].id = 'select item first'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.isError.items[i].qty = true
          this.error_msg.items[i].qty = 'qty must > 0 and <= stock'
          this.items_checked = false
          break
        }

        if (this.inputData.items[i].qty <= this.items_temp[i].stock) {
          this.items_checked = true
        } else {
          this.loading.createButton = false
          this.showToast(
            'error',
            'Error Message',
            'Qty must be less than stock'
          )
          return
        }

        if (!this.outlet_id)
          if (
            !this.inputData.items[i].qty <= 0 ||
            !this.inputData.items[i].qty === '0' ||
            !this.inputData.items[i].qty === ''
          ) {
            this.items_checked = true
          } else {
            this.loading.createButton = false
            this.isError.items[i].qty = true
            this.error_msg.items[i].qty = 'qty must > 0 and <= stock'
            this.items_checked = false
            break
          }
        this.inputData.items[i].description = this.items_temp[i].description
      }
      if (
        this.total_price >= 0 &&
        this.total_qty >= 0 &&
        this.inputData.warehouse_id_destination != 0 &&
        this.inputData.doc_number != '' &&
        this.inputData.doc_date != '' &&
        this.items_checked
      ) {
        this.loading.createButton = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/transfer`,
            this.inputData
          )
          .then(response => {
            if (response.status === 200) {
              this.showToast(
                'success',
                'Submit items Success',
                'Congrats, those items has been submitted'
              )
              this.total_price = 0
              this.total_qty = 0
              this.items_temp = [
                {
                  qty: 0,
                  price: 0,
                  total: 0
                }
              ]
              this.selectedWarehouse = null
              this.inputData = {
                warehouse_id_destination: 0,
                // doc_number: '',
                doc_date: '',
                items: [
                  {
                    id: 0,
                    qty: 0,
                    description: null
                  }
                ]
              }
              setTimeout(() => {
                this.getListWarehouse()
                this.getItems()
              }, 500)
              this.loading.createButton = false
            } else {
              this.loading.createButton = false
              this.showToast(
                'error',
                'Submit items Failed',
                "Sorry, those items hasn't submitted. CHECK the stock first"
              )
            }
          })
      }
    },

    deleteRow(index, an_item) {
      let idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.inputData.items.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
      this.calculateTotal()
    },

    addNewRow() {
      this.items_temp.push({
        // code: '',
        name: '',
        price: 0,
        qty: null,
        total: 0
      })
      this.inputData.items.push({
        id: 0,
        qty: null
      })
      this.isError.items.push({ id: false, qty: false })
      this.error_msg.items.push({ id: '', qty: '' })
      this.calculateTotal()
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
